module.exports = __webpack_public_path__ + "img/icon-coffee.2a441655.svg";